import { Dialog } from '@hai/ui-react';
import React, { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onReboot?: VoidFunction;
  onCancel?: VoidFunction;
}

export const RebootConfirmModal: React.FunctionComponent<Props> = ({ onReboot, onCancel }) => {
  const { t } = useTranslation();

  useLayoutEffect((): void => {
    const el = document.getElementById('reboot-cancel-button');
    if (el) {
      el.focus();
      el.classList.add('force-focus-visible'); // Add class to force focus-visible styles
    }
  }, []);

  return (
    <Dialog
      headline={t('reboot.confirm.title')}
      onClose={onCancel}
      show={true}
      buttons={[
        { label: t('general.cancel'), id: 'reboot-cancel-button' },
        { label: t('general.reboot'), variant: 'danger', onClick: onReboot },
      ]}
    />
  );
};
